import { send } from 'server';

export const getPlayerSelfExclusion = () => send({
    ID: 35601,
    responses: [35602, 35603],
    description: 'Get Player Self Exclusion'
});
